/*
 * Producer -- Jimmy
 * Function -- Mini购物车
 */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as index from "../../actions/index";
import * as global from "../../actions/global";
import MyVideo from '../molecules/Video/index';

class HomeContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _static: "https://ssl1.sephorastatic.cn",
      imgUrl: ''
    };
  }
  componentDidMount() {
    const _homeConfig = this.props._homeConfig;
    if(_homeConfig) this.setState({showImg: true})
    if (_homeConfig && window && window.__INITIAL_ENV__) {
      const envStatic = window.__INITIAL_ENV__.static || "https://ssl1.sephorastatic.cn";
      this.setState({
        _static: envStatic,
        imgUrl: envStatic + "/soa/pc/images/20240724_PC_HP_V101_10.png"
      })
    }
  }

  render() {
    const {aboutSephoraList, featureIconList} = this.props.configData;
    const { _static, imgUrl } = this.state;
    let currnEl = '';
    const MYVIDEO = aboutSephoraList.filter(x => x.type === 'video')[0];
    const MYIMAGE = aboutSephoraList.filter(x => x.type === 'image')[0];
    if(MYVIDEO) {
      currnEl = <MyVideo src={MYVIDEO.videoUrl} height='100%' width='100%' poster={MYVIDEO.imageCover} /> 
    };
    if(MYIMAGE ) {
      currnEl = <img height='100%' width='100%' src={MYIMAGE.imageCover}></img>
    };
    const aboutText = aboutSephoraList.filter(x => x.type === 'text')[0].textContent;
    return (
      <div id="HomeContent">
        <div className="home-content-info">
            <div className="home-content-banner">
                <img
                  src={imgUrl}
                  alt=""
                />
            </div>
            <div className="home-content-publicity">
              <div  className="home-content-publicity-box">
                {featureIconList && featureIconList.map(item => {
                  return (
                    <div className="item">
                      <img src={item.icon} alt="Sephora"></img>
                      <div className="title">{item.title}</div>
                      <div className="text" dangerouslySetInnerHTML={{ __html: item.content }} />
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="home-content-recommend">
              <div className="title">
                <img
                  src={_static + "/soa/pc/images/20240724_PC_HP_V101_32.png"}
                  alt="">
                  </img>
              </div>
              <div  className="recommend-bottom-box">
              <div className="recommend-bottom">
                <div className="left-pic">
                  {currnEl}
                  {/* {currnEl === 'video' ? <MyVideo src={MYVIDEO.videoUrl} height='100%' width='100%' poster={MYVIDEO.imageCover} /> : <img src={MYIMAGE.imageCover}></img>} */}
                </div>
                <div className="right-content" dangerouslySetInnerHTML={{ __html: aboutText }}></div>
              </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    _homeConfig: state.homeConfig,
  }),
  (dispatch) => ({
    index: bindActionCreators(index, dispatch),
    global: bindActionCreators(global, dispatch),
    dispatch,
  }),
)(HomeContent);



// WEBPACK FOOTER //
// ./common/components/HomeContent/index.js